import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import { Typography, Box } from '@mui/material';
import { DuplicateIcon, UtmCloseIcons } from '../../icons';
import { buildCampaignLink } from '../../containers/campaign-container/utils';
export default function UtmLinkModal({ onClose, open, data }) {

    const [isCopied, setIsCopied] = React.useState(false)

    const link = React.useMemo(() => {
        return buildCampaignLink(data);
    }, [data]);

    const handleClick = () => {
        if (link && link !== '-') {
            navigator.clipboard.writeText(link);
        }

        setIsCopied(true);
        setTimeout(() => {
            setIsCopied(false);
        }, 1500);
    };

    return (
        <React.Fragment>

            <Dialog
                open={open}
                onClose={onClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                sx={{
                    '& .MuiPaper-root': {
                        padding: '20px 14px',
                        width: '360px',
                        borderRadius: '7px'
                    }
                }}
            >
                <Box>
                    <Box sx={{ marginBottom: '12px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '20px' }}>
                        <Box>
                            <Typography sx={{ color: '#101828', fontWeight: '500', fontSize: '18px', fontFamily: 'Neue Montreal' }}>UTM Link</Typography>
                            <Typography sx={{ color: '#4A5565', fontWeight: '400', fontSize: '14px', fontFamily: 'Neue Montreal' }}>
                                Campaign Name: {data?.name}
                            </Typography>
                        </Box>
                        <UtmCloseIcons onClick={onClose} />
                    </Box>

                    <Box sx={{ background: '#F0F9FD', borderRadius: '10px', padding: '12px', display: 'flex', justifyContent: 'space-between', alignItems: 'start', gap: '12px' }}>
                        <Typography sx={{ color: '#1F1F1F', fontWeight: '400', fontSize: '14px', fontFamily: 'Neue Montreal', wordBreak: 'break-all', flex: 1 }}>
                            {link}
                        </Typography>
                        <Box sx={{ minWidth: '32px', display: 'flex', justifyContent: 'end', position: 'relative', cursor: 'pointer', overflow: 'visible' }} onClick={handleClick} >
                            <DuplicateIcon />
                            {
                                isCopied && (
                                    <span style={{
                                        background: '#00000080', color: '#fff', fontWeight: '400', borderRadius: '40px', padding: '3px 14px', fontSize: '10px',
                                        position: 'absolute', top: '-26px', zIndex: '999', left: '-17px'
                                    }}>
                                        Copied
                                    </span>
                                )
                            }
                        </Box>
                    </Box>

                </Box>
            </Dialog>
        </React.Fragment>
    );
}
